enum SimplifiedPlayPositions {
  FORWARD = "position.forward",
  MIDFIELD = "position.midfield",
  DEFENSIVE = "position.defensive",
  GOALKEEPER = "position.goalkeeper",
}

export default SimplifiedPlayPositions;
